import React, { useState } from 'react';
import {
  Modal,
  Box,
  Title,
  createStyles,
  clsx,
  Text,
  Group,
  Button,
  Flex,
} from "@mantine/core";

import {COLORS} from "../../AIRecipes/costansts";

import heartSvg from "../../../assets/img/heart.svg";
import aiSvg from "../../../assets/img/ai.svg";
import losSvg from "../../../assets/img/los.svg";
import hospitalSvg from "../../../assets/img/hospitalAI.svg";
import aiStartsSvg from "../../../assets/img/mdi_stars.svg";

const useStyles = createStyles((theme) => ({
  heading: {
    fontWeight: 700,
    fontSize: "20px",
    lineHeight: "28px",
    color: "#262930",
    textAlign: "center",
  },
  recipeButton: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '12px',
    border: '1px solid #E0E0E0',
    borderRadius: '8px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: '#F5F5F5',
    },
  },
  recipeButtonActive: {
    border: `1px solid ${theme.colors.blue[6]}`,
    backgroundColor: theme.colors.blue[0],
  },
  imageStyle: {
    width: "24px",
    height: "24px",
    marginBottom: '8px',
    
  },
  label: {
    fontSize: '14px',
    fontWeight: 500,
  },
  generateButton: {
    marginTop: '28px',
    justifyContent: 'right',
    display: 'flex',
  },
  "filter-blue": {
    filter: "invert(35%) sepia(96%) saturate(778%) hue-rotate(175deg) brightness(88%) contrast(91%)"
  },
  ai: {
    minWidth: "104px",
    height: "74px,",
    padding: "8px",
    borderRadius: "8px",
    gap: "8px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: '#ceeaff',
      border: "1px solid #1B75BC",
      
    },
  },
}));
  
interface AIRecipesModalProps {
  opened: boolean;
  onClose: () => void;
  submit: (i: number) => Promise<void> | void;
}

export const AIRecipesModal: React.FC<AIRecipesModalProps> = ({ opened, onClose, submit}) => {
  const { classes } = useStyles();
  const [showAi, setShowAi] = useState<number | null>(null);

  const recipeList = [
    { label: "Summary", value: 1, icon: aiSvg },
    { label: "Cardiovascular", value: 2, icon: heartSvg },
    { label: "Length of Stay", value: 3, icon: losSvg },
    { label: "Readmission", value: 4, icon: hospitalSvg },
  ];

  return (
    <Modal opened={opened} onClose={onClose}  size="lg" title={<Title order={3} className={classes.heading}>Select AI Recipe</Title>} centered>
      <Box>
        <Group position="center" spacing="md" style={{ marginTop: "18px" }}grow>
          {recipeList.map((recipe, i) => (
           <Box
           className={classes.ai }
           sx={{
             border: showAi == i+1
               ? "1px solid " + COLORS.borderBlue
               : "1px solid " + COLORS.borderGray,
           }}
           onClick={() => setShowAi(i+1)}
         >
           <img
             src={recipe.icon}
             className={classes.imageStyle + " " + (showAi == i+1 ? classes["filter-blue"] : '')}
           />
           <Text color={showAi == i+1 ? COLORS.borderBlue: COLORS.textBlack}>{recipe.label}</Text>
         </Box>))}
        </Group>
        <Flex className={classes.generateButton}>
          <Button variant="outline" onClick={() => submit(showAi??0)} leftIcon={<img src={aiStartsSvg} alt="AI" />}>
            Generate
          </Button>
        </Flex>
      </Box>
    </Modal>
  );
};
